import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bag-dark",
  "use": "bag-dark-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bag-dark\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2C9.79086 2 8 3.79086 8 6V7H3C2.44772 7 2 7.44772 2 8V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V8C22 7.44772 21.5523 7 21 7H16V6C16 3.79086 14.2091 2 12 2ZM14 9V11H16V9H20V20H4V9H8V11H10V9H14ZM14 7V6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6V7H14Z\" fill=\"#757575\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol